// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__XjIuw","social":"socials__social__G209F","icon":"socials__icon__cTnj8","navOpen":"socials__navOpen__pJeUm"};